import { render } from "./product4.vue?vue&type=template&id=361eb8e3&scoped=true"
import script from "./product4.vue?vue&type=script&lang=js"
export * from "./product4.vue?vue&type=script&lang=js"

import "./product4.vue?vue&type=style&index=0&id=361eb8e3&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361eb8e3"]])

export default __exports__